// Settings › General › Modules: the optional parts of the workspace (activities, meetings, meeting notes).
import { createFileRoute } from '@tanstack/react-router';
import { ModulesPage } from '../../../features/access/ModulesPage';

export const Route = createFileRoute('/_settings/settings/modules')({ component: ModulesPage });
